import { setAlpha, toCSSColor } from '@printu/geom';
import { compilePath } from 'app/core/rendering/compiler';
import { getTextFillPainter, renderText, } from 'app/image/rasterize/markers/text/text';
export const renderTextCloudMarkerBackground = (marker, fonts, ctx) => {
    const { background } = marker;
    const { data } = background;
    ctx.save();
    if (data) {
        const painter = compilePath(data, false);
        // const path = new Path2D(data);
        ctx.save();
        ctx.translate(marker.x, marker.y - marker.lines[0].ascent);
        ctx.fillStyle = toCSSColor(setAlpha(marker.color, 0.6));
        ctx.strokeStyle = marker.color;
        ctx.lineWidth = 1.0;
        painter(ctx);
        ctx.fill();
        ctx.stroke();
        ctx.restore();
    }
    const fillPainter = getTextFillPainter(marker);
    renderText(marker, fonts, ctx, _style => {
        ctx.save();
        ctx.fillStyle = '#FFFFFF';
        fillPainter(ctx);
        ctx.restore();
    });
    ctx.restore();
};
